import React from "react";
import { connect } from "react-redux";
import { IAppState } from "../state/interfaces";
import QuoteStep from "./QuoteStepLayout";
import { IRate, IPaymentChoice, ICoverageConfig } from "../classes/Domain";
import ReactLoading from 'react-loading';
import { PATHS, QUOTE_STEPS, APP_CONFIG } from "../AppConstants";
import RateResult from '../components/RateResult';
import CoveragesApiClient from "../classes/CoveragesApiClient";
import Utilities from "../classes/Utilities";
import { IQuoteStepComponentProps, IQuoteStepState } from "../components/interfaces";
import { quoteStepChanged, selectPaymentChoice } from "../state/appActions";
import QuoteStepBase from '../components/QuoteStepBase';
import AuthorizeVerify from '../components/AuthorizeVerify';
import BravoApiClient from "../classes/BravoApiClient";
import ButtonContinue from "../components/ButtonContinue";
import { fillExternalQuote } from "../state/fullQuoteActions";

interface IState extends IQuoteStepState  {
    rateResult: IRate | null,
    apiCallError: boolean,
    updatingStore: boolean,
    loadingRates: boolean,
    choiceSelected: boolean,
    issueChoice: boolean,
    paymentChoice: IPaymentChoice | null;
}

interface IResultComponentProps extends IQuoteStepComponentProps {
    quoteUid: string,
    coverageConfig: ICoverageConfig,
    fillExternalQuote: (update: any) => Promise<any>;
}

class Result extends QuoteStepBase<IResultComponentProps, IState> {
    constructor(props: IResultComponentProps) {
        super(props);
        this.onPaymentChoiceSelected = this.onPaymentChoiceSelected.bind(this);
        this.issueNow = this.issueNow.bind(this);
        this.onApiCallError = this.onApiCallError.bind(this);

        this.state = {
            rateResult: null,
            apiCallError:false,
            updatingStore:false,
            loadingRates: false,
            choiceSelected: false,
            issueChoice: false,
            paymentChoice: null
        };
    }

    componentDidMount() 
    {
        super.componentDidMount();
        this.getRates();
    }

    getRates() {
        const coveragesApiClient = new CoveragesApiClient();

        this.setState({ loadingRates: true }, () => {
            coveragesApiClient
                .getRates(this.props.quoteUid, this.props.coverageConfig)
                .then((response) => {

                    const anyPaymentChoices = response.data.paymentChoices && 0 < response.data.paymentChoices.length;

                    if (!anyPaymentChoices) {
                        this.props.updateAppState({
                            quoteUid: this.props.quoteUid,
                            rate: null,
                            paymentChoice: null,
                            agenciesContactInfo: response.data.agenciesContactInfo
                        });

                        this.props.history.replace(PATHS.AGENCIES);
                        return;
                    }

                    if (anyPaymentChoices) {
                        response.data.paymentChoices[0].selected = true;
                    }

                    this.setState({
                        ...this.state,
                        rateResult: {
                            rate: response.data.rate,
                            paymentChoices: response.data.paymentChoices,
                            agenciesContactInfo: response.data.agenciesContactInfo,
                            isError: response.data.isError,
                            offerErrors : response.data.offerErrors
                        },
                        loadingRates: false,
                        paymentChoice: anyPaymentChoices ? response.data.paymentChoices[0] : null,
                        choiceSelected: true
                    }, () => {
                            this.props.updateAppState({
                                quoteUid: this.props.quoteUid,
                                rate: this.state.rateResult?.rate,
                                paymentChoice: this.state.paymentChoice,
                                agenciesContactInfo: this.state.rateResult?.agenciesContactInfo
                            })
                    });
                },
                () => {
                    this.setState({ ...this.state, loadingRates: false })
                });
        });
    }

    onApiCallError() {
        this.setState({ ...this.state, choiceSelected: false, issueChoice: false });
    }

    issueNow() {
        if (this.state.choiceSelected)
        {
            var bravoApiClient = new BravoApiClient();

            this.setState({ ...this.state, choiceSelected: true, issueChoice: true }, () => {
                const selectedRate = { ...this.state.rateResult?.rate, urlMemo: this.state.paymentChoice?.urlMemo ?? "", quoteUid: this.props.quoteUid };

                bravoApiClient.createtQuote(selectedRate)
                    .then((response) => {
                        const quoteId = parseInt(response.data, 10);

                        bravoApiClient.getQuote(quoteId)
                            .then((qResponse) => {
                                qResponse.data.rtrQuoteId = quoteId;
                                this.props.fillExternalQuote({ quote: qResponse.data })
                                    .then(() => this.props.history.replace(Utilities.formatUrl(PATHS.FQ_CARS, "")));
                            });
                    }, this.onApiCallError)
            });
        }
    }

    onPaymentChoiceSelected(paymentChoice: IPaymentChoice) {
        this.state.rateResult?.paymentChoices.filter(x => x.urlMemo != paymentChoice.urlMemo).forEach(x => x.selected = false);

        this.setState({
            rateResult: this.state.rateResult,
            paymentChoice: paymentChoice.selected ? paymentChoice : null,
            choiceSelected: paymentChoice.selected
        }, () => {
                this.props.updateAppState({
                    quoteUid: this.props.quoteUid,
                    rate: this.state.rateResult?.rate,
                    paymentChoice: this.state.paymentChoice,
                    agenciesContactInfo: this.state.rateResult?.agenciesContactInfo
                })
        })
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="logo-frame" style={{ textAlign: "center" }}>
                    <img className="logo" src={this.state.rateResult?.rate.urlLogo} />
                </div>

                <AuthorizeVerify />
                <div className="quote-step rates">
                    {this.state.loadingRates
                        ? <div className={"w-100 loading-indicator"}><ReactLoading type={"spin"} color={"#007bff"} height={'40px'} width={'40px'} /></div>
                        : null
                    }

                    {!this.state.loadingRates && null !== this.state.rateResult
                        ? <div>
                            {[
                                this.state.rateResult 
                            ].map((rate, idx) => (
                                <RateResult
                                    key={Utilities.uniqueId()}
                                    rateResult={rate}
                                    index={idx}
                                    onPaymentChoiceSelected={this.onPaymentChoiceSelected}
                                    reRate={() => this.getRates()} />
                            ))}
                        </div>
                        : null
                    }
                </div>
                <br />
                <div className="choice">
                    <div className="text-center">
                        <ButtonContinue
                            disabled={this.state.loadingRates || this.state.rateResult?.paymentChoices.every(x => !x.selected)}
                            showLoading={this.state.choiceSelected && this.state.issueChoice}
                            label="Buy Now"
                            onClick={this.issueNow} />

                        {
                            this.state.loadingRates || !this.state.rateResult?.paymentChoices.length
                                ? null
                                : <AuthorizeVerify />
                        }
                    </div>
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        quoteUid: state.quoteUid,
        coverageConfig: state.coverageConfig
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(QUOTE_STEPS.COVERAGES)),
        updateAppState: (update) => dispatch(selectPaymentChoice(update.quoteUid, update.rate, update.paymentChoice, update.agenciesContactInfo)),
        fillExternalQuote: (update) => dispatch(fillExternalQuote(update.quote))
    };
};

export default connect(mapProps, mapDispatch)(Result);
